import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import GuidesCard from "../GuidesResources/GuidesCard";
import Slider from "react-slick";
import $ from "jquery";

import {news_slider_count} from "../../common/constant"

//import {LatestNews} from "../../common/queries/common_use_query"
import "./News.scss";


const MoreGuides = ({id}) => {

    //const{loading, error, data} = LatestNews();

    const data = useStaticQuery(graphql`
      query MoreGuideQuery{
        glstrapi {
            guidesAndResources(sort:"createdAt:desc", publicationState: LIVE) {
                id
                title
                slug
                guides_categories {
                    id
                    category_name
                }
                image {
                    url
                    alternativeText
                }
                imagetransforms
                ggfx_results {
                    id
                    content_type
                    transforms
                    src_import_url
                    src_cftle
                    field
                }
            }

        }
    }`)

    var guides = data.glstrapi?.guidesAndResources;

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: news_slider_count || 4,
        slidesToScroll: 1,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.news .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const [icon, setIcon] = useState(false);

    //console.log("Module ==>", Module)

    return (
        <>
            <section className={`news more_guides`}>
                <Container>
                    <Row>
                        <Col>
                            <h2>More Guides</h2>

                            {guides?.length > 0 && 
                                <Slider {...settings}>
                                    {guides?.filter(item => item.id !== id).map((item, index) => (
                                        <GuidesCard item={item} imagename={"guides-and-resources.image.card_image"} />
                                    ))}
                                </Slider>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default MoreGuides;